export enum FormSystem {
  'TASKS' = 'TASKS',
  'PAYMENT' = 'PAYMENT',
  'PORTAL' = 'PORTAL',
  'DOCUMENT_REVIEW' = 'DOCUMENT_REVIEW',
  'ACTIVITIES' = 'ACTIVITIES',
}
